<template>
  <div class="params-seeting">
    <div class="tab-wrap clearfix">
      <div>
        <ul class="clearfix">
          <router-link v-for="(item,index) in menus" :key="index" tag="li" :to="item.path"  @click.native="check(item.path)" :class="{'active':active(item.path)}">{{item.name}}</router-link>

          <!-- <router-link tag="li" to="/paramsSeeting" :class="{'active':activeIndex==1}" @click.native="active(1)">上下限自动控制</router-link>
          <router-link tag="li" to="/paramsSeeting/timeControl" :class="{'active':activeIndex==2}" @click.native="active(2)">时间表自动控制</router-link> -->
        </ul>
        <div class="alarm">警报电话 : <span>{{this.alarmPhone}}</span></div>
      </div>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import index from '../../store/modules/index'
import { mapState } from 'vuex'
export default {
  name: 'ParamsSeeting',
  data () {
    return {
      alarmPhone: '', // 警报电话1
      activeIndex: 1,
      menus: [
        { path: '/paramsSeeting', name: '上下限自动控制' },
        { path: '/paramsSeeting/timeControl', name: '时间表自动控制' }
      ]
    }
  },
  watch: {
    equipmentId (value) {
      let a = this.equipmentList.find(f => f.id === value)
      if (a) {
        this.alarmPhone = a.alarmPhone
      }
    },
    equipmentList (value) {
      let a = value.find(f => f.id === this.equipmentId)
      if (a) {
        this.alarmPhone = a.alarmPhone
      }
    }
  },
  computed: {
    ...mapState(index, ['equipmentId', 'equipmentList'])
  },
  mounted () {
    if (this.equipmentId && this.equipmentList) {
      let a = this.equipmentList.find(f => f.id === this.equipmentId)
      if (a) {
        this.alarmPhone = a.alarmPhone
      }
    }
  },
  methods: {
    check (path) {
      // if (path === '/paramsSeeting/timeControl') {
      //   this.$message({
      //     message: '时间表自动控制正在建设中',
      //     duration: 3000
      //   })
      // }
    },
    active (path) {
      return this.$route.path === path
    }
  }
}
</script>

<style lang="stylus" scoped>
.params-seeting
  padding 25px
.tab-wrap
  margin-bottom 20px
  // background rgba(22,75,153,.3);
  ul
    display inline-block
    border 1px solid #07f;
    border-radius 4px;
  li
    float left
    width 176px
    padding 0 20px
    line-height 36px
    text-align center
    list-style none
    cursor pointer
    font-size 16px
    color #BBD4E9
  .active
    color #fff
    // background linear-gradient(0deg,rgba(24,149,255,1),rgba(0,84,255,1))
    background:rgba(0,119,255,1);
  .alarm
    float right
    line-height 36px
    font-size 18px
    color #BBD4E9
    span
      margin-left 10px
      padding 0 20px
      border 1px solid #07f
      border-radius 4px
</style>
